<template>
  <!-- 承德市中医院 -->
  <div class="pageContent">
    <!-- <img src="../../../assets/wuxue.png" alt="Login logo" class="loginLogo" /> -->
    <!-- <div class="hosName">承德市中医院</div> -->
    <!-- 病历号，身份证号，住院号 -->
    <div class="ourterTitle">输入姓名/身份证号绑定数字影像</div>
    <div class="bindDetails">
      <div class="IDNumber">
        <van-field
          v-model.trim="value012.name012"
          placeholder="请输入姓名"
          @input.native="inputFn"
        />
      </div>
      <div class="IDNumber">
        <van-field
          v-model.trim="value012.value1"
          placeholder="请输入身份证绑定信息"
          @input.native="inputFn"
        />
      </div>
      <footer class="footer">
        <van-button type="primary" :disabled="rules" @click.native="nextFn"
          >下一步</van-button
        >
      </footer>
    </div>
  </div>
</template>
<script>
import { bind, dockCheckCaptcha } from "@/api/login";
import Storage from "@/tools/storage";
export default {
  data() {
    return {
      rules: true,
      value012: {
        name012: "",
        value1: "",
      },
    };
  },
  methods: {
    inputFn() {
      if (this.value012.name012 != "" && this.value012.value1 != "" && (this.value012.value1.length==18 ||this.value012.value1.length==15)) {
        this.rules = false;
      } else {
        this.rules = true;
      }
    },
    nextFn() {
      // let institution_id = window.location.href.split("/checkInfoOuter/search?institution_id=")[1];
      window.localStorage.setItem("value012", JSON.stringify(this.value012));
      window.localStorage.setItem("institution_id", '012');
      // institution_id=VGNlNWFXdldoVzRMTzlZUkRsUmxFZU5ZSkcvSHR2c0NYMkVKMmtFK2xjND0%3D&type=1&code=YitsL3NzNkQwL1h1UUtCUlhEd2wzdz09
      this.$router.push({
        path: "/reportListOuter",
      });
    },
  },
  created() {
    window.localStorage.clear();
    // institution_id=VGNlNWFXdldoVzRMTzlZUkRsUmxFZU5ZSkcvSHR2c0NYMkVKMmtFK2xjND0%3D&type=1&code=YitsL3NzNkQwL1h1UUtCUlhEd2wzdz09
    // let institution_id = window.location.href.split("/checkInfoOuter/search?institution_id=")[1];
    // console.log(institution_id);
    if (window.localStorage.getItem("name012")) {
      this.$router.push({
        path: "/reportListOuter",
      });
    }
  },
};
</script>
<style lang="scss" scoped>
.pageContent {
  .hosName {
    font-size: 20px;
    // padding: 10px 0;
    padding: 65px 0 10px;
    font-weight: 800;
  }
  .ourterTitle {
    padding: 60px 0 20px;
    font-size: 18px;
    font-weight: 500;
  }
  .bindDetails {
    width: 90%;
    margin: 0 auto;
  }
}
</style>
